import React from 'react';
import { methods } from './data/methodsMetadata';
import styles from './Guide.module.css';

const MethodSelector = ({ onSelect, onInfo }) => {
  return (
    <div className={styles['method-selector-grid']}>
      {methods.map((method) => (
        <div key={method.id} className={styles['method-card']}>
          <div className={styles['method-icon']}>{method.icon}</div>
          <h3>{method.title}</h3>
          <p>{method.shortDesc}</p>
          <div className={styles['method-card-buttons']}>
            <button onClick={() => onInfo(method.id)}>ℹ️ Infos</button>
            <button onClick={() => onSelect(method.id)}>Choisir</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MethodSelector;